<template>
  <svg class="svg-icon ml-2" width="25.401" height="23.401" :style="getSvgColor" style="vertical-align: middle;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M752.213333 530.773333h-460.8c-18.773333 0-34.133333-15.36-34.133333-34.133333s15.36-34.133333 34.133333-34.133333h460.8c18.773333 0 34.133333 15.36 34.133334 34.133333s-14.933333 34.133333-34.133334 34.133333zM163.413333 870.4v-204.8c0-18.773333-15.36-34.133333-34.133333-34.133333s-34.133333 15.36-34.133333 34.133333v221.866667c0 28.16 23.04 51.2 51.2 51.2h221.866666c18.773333 0 34.133333-15.36 34.133334-34.133334s-15.36-34.133333-34.133334-34.133333h-204.8zM163.413333 153.6h204.8c18.773333 0 34.133333-15.36 34.133334-34.133333s-15.36-34.133333-34.133334-34.133334h-221.866666c-28.16 0-51.2 23.04-51.2 51.2v221.866667c0 18.773333 15.36 34.133333 34.133333 34.133333s34.133333-15.36 34.133333-34.133333V153.6zM880.213333 870.4h-204.8c-18.773333 0-34.133333 15.36-34.133333 34.133333s15.36 34.133333 34.133333 34.133334h221.866667c28.16 0 51.2-23.04 51.2-51.2v-221.866667c0-18.773333-15.36-34.133333-34.133333-34.133333s-34.133333 15.36-34.133334 34.133333v204.8zM897.28 85.333333h-221.866667c-18.773333 0-34.133333 15.36-34.133333 34.133334s15.36 34.133333 34.133333 34.133333h204.8v204.8c0 18.773333 15.36 34.133333 34.133334 34.133333s34.133333-15.36 34.133333-34.133333V136.533333c0-28.16-22.613333-51.2-51.2-51.2z" /></svg></template>

<script>
export default {
  name: "loyaltySvg",
  props: {
    navColor: {
      type: Object,
      default: () => {
        return {
          color: "#000000"
        };
      }
    },
  },
  computed: {
    getSvgColor() {
      if(!this.navColor) {
        return {
          fill: "#000000"
        };
      }
      return {
        fill: this.navColor.color || "#fff",
      };
    },
  },
}
</script>

